import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_EMAIL_CAMPAIGNS_LIST = gql`
query getEmailCampaigns($appName: String, $kind: String, $isActive: Boolean, $search: String) {
  getEmailCampaigns(appName: $appName, kind: $kind, isActive: $isActive, search: $search) {
    isAuth
    total
    error
    campaigns {
      key
      title
      kind
      isActive
      templateCount
        inactiveCount
      hasAnyTemplate
      createdAt
      languages {
        language
        status
      }
    }
  }
}
`;

const getEmailCampaignsList = async (variables) => {
  try {
    const result = await client.query({
      query: GET_EMAIL_CAMPAIGNS_LIST,
      variables,
      errorPolicy: 'all',
      fetchResults: true,
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { getEmailCampaigns: campaignsData } } = result;

    if (campaignsData) {
      return campaignsData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getEmailCampaignsList = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getEmailCampaignsList Error: ${error}`);
    return null;
  }
};

export default getEmailCampaignsList;
